import { render } from "./AccessDenied.vue?vue&type=template&id=de11d074&scoped=true"
const script = {}

import "./AccessDenied.vue?vue&type=style&index=0&id=de11d074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de11d074"]])

export default __exports__